/* eslint-disable */
/** Auto-generated by scripts/split-expertise-city.mjs — do not edit. */

import core_arbeitsrecht_kaiserslautern from "./expertiseCity/core/arbeitsrecht/kaiserslautern.json";
import judgements_arbeitsrecht_kaiserslautern from "./expertiseCity/judgements/arbeitsrecht/kaiserslautern.json";
import core_arbeitsrecht_koblenz from "./expertiseCity/core/arbeitsrecht/koblenz.json";
import judgements_arbeitsrecht_koblenz from "./expertiseCity/judgements/arbeitsrecht/koblenz.json";
import core_arbeitsrecht_landau_pfalz from "./expertiseCity/core/arbeitsrecht/landau-pfalz.json";
import judgements_arbeitsrecht_landau_pfalz from "./expertiseCity/judgements/arbeitsrecht/landau-pfalz.json";
import core_arbeitsrecht_muenchen from "./expertiseCity/core/arbeitsrecht/muenchen.json";
import judgements_arbeitsrecht_muenchen from "./expertiseCity/judgements/arbeitsrecht/muenchen.json";
import core_arbeitsrecht_pirmasens from "./expertiseCity/core/arbeitsrecht/pirmasens.json";
import judgements_arbeitsrecht_pirmasens from "./expertiseCity/judgements/arbeitsrecht/pirmasens.json";
import core_arbeitsrecht_stuttgart from "./expertiseCity/core/arbeitsrecht/stuttgart.json";
import judgements_arbeitsrecht_stuttgart from "./expertiseCity/judgements/arbeitsrecht/stuttgart.json";
import core_erbrecht_kaiserslautern from "./expertiseCity/core/erbrecht/kaiserslautern.json";
import judgements_erbrecht_kaiserslautern from "./expertiseCity/judgements/erbrecht/kaiserslautern.json";
import core_erbrecht_koblenz from "./expertiseCity/core/erbrecht/koblenz.json";
import judgements_erbrecht_koblenz from "./expertiseCity/judgements/erbrecht/koblenz.json";
import core_erbrecht_landau_pfalz from "./expertiseCity/core/erbrecht/landau-pfalz.json";
import judgements_erbrecht_landau_pfalz from "./expertiseCity/judgements/erbrecht/landau-pfalz.json";
import core_erbrecht_muenchen from "./expertiseCity/core/erbrecht/muenchen.json";
import judgements_erbrecht_muenchen from "./expertiseCity/judgements/erbrecht/muenchen.json";
import core_erbrecht_pirmasens from "./expertiseCity/core/erbrecht/pirmasens.json";
import judgements_erbrecht_pirmasens from "./expertiseCity/judgements/erbrecht/pirmasens.json";
import core_erbrecht_stuttgart from "./expertiseCity/core/erbrecht/stuttgart.json";
import judgements_erbrecht_stuttgart from "./expertiseCity/judgements/erbrecht/stuttgart.json";
import core_gesellschaftsrecht_heilbronn from "./expertiseCity/core/gesellschaftsrecht/heilbronn.json";
import judgements_gesellschaftsrecht_heilbronn from "./expertiseCity/judgements/gesellschaftsrecht/heilbronn.json";
import core_gesellschaftsrecht_kaiserslautern from "./expertiseCity/core/gesellschaftsrecht/kaiserslautern.json";
import judgements_gesellschaftsrecht_kaiserslautern from "./expertiseCity/judgements/gesellschaftsrecht/kaiserslautern.json";
import core_gesellschaftsrecht_koblenz from "./expertiseCity/core/gesellschaftsrecht/koblenz.json";
import judgements_gesellschaftsrecht_koblenz from "./expertiseCity/judgements/gesellschaftsrecht/koblenz.json";
import core_gesellschaftsrecht_koeln from "./expertiseCity/core/gesellschaftsrecht/koeln.json";
import judgements_gesellschaftsrecht_koeln from "./expertiseCity/judgements/gesellschaftsrecht/koeln.json";
import core_gesellschaftsrecht_landau_pfalz from "./expertiseCity/core/gesellschaftsrecht/landau-pfalz.json";
import judgements_gesellschaftsrecht_landau_pfalz from "./expertiseCity/judgements/gesellschaftsrecht/landau-pfalz.json";
import core_gesellschaftsrecht_muenchen from "./expertiseCity/core/gesellschaftsrecht/muenchen.json";
import judgements_gesellschaftsrecht_muenchen from "./expertiseCity/judgements/gesellschaftsrecht/muenchen.json";
import core_gesellschaftsrecht_pirmasens from "./expertiseCity/core/gesellschaftsrecht/pirmasens.json";
import judgements_gesellschaftsrecht_pirmasens from "./expertiseCity/judgements/gesellschaftsrecht/pirmasens.json";
import core_gesellschaftsrecht_stuttgart from "./expertiseCity/core/gesellschaftsrecht/stuttgart.json";
import judgements_gesellschaftsrecht_stuttgart from "./expertiseCity/judgements/gesellschaftsrecht/stuttgart.json";
import core_insolvenzrecht_koblenz from "./expertiseCity/core/insolvenzrecht/koblenz.json";
import judgements_insolvenzrecht_koblenz from "./expertiseCity/judgements/insolvenzrecht/koblenz.json";
import core_insolvenzrecht_koeln from "./expertiseCity/core/insolvenzrecht/koeln.json";
import judgements_insolvenzrecht_koeln from "./expertiseCity/judgements/insolvenzrecht/koeln.json";
import core_insolvenzrecht_landau_pfalz from "./expertiseCity/core/insolvenzrecht/landau-pfalz.json";
import judgements_insolvenzrecht_landau_pfalz from "./expertiseCity/judgements/insolvenzrecht/landau-pfalz.json";
import core_internetmedienrecht_kaiserslautern from "./expertiseCity/core/internetmedienrecht/kaiserslautern.json";
import judgements_internetmedienrecht_kaiserslautern from "./expertiseCity/judgements/internetmedienrecht/kaiserslautern.json";
import core_internetmedienrecht_koblenz from "./expertiseCity/core/internetmedienrecht/koblenz.json";
import judgements_internetmedienrecht_koblenz from "./expertiseCity/judgements/internetmedienrecht/koblenz.json";
import core_internetmedienrecht_landau_pfalz from "./expertiseCity/core/internetmedienrecht/landau-pfalz.json";
import judgements_internetmedienrecht_landau_pfalz from "./expertiseCity/judgements/internetmedienrecht/landau-pfalz.json";
import core_internetmedienrecht_muenchen from "./expertiseCity/core/internetmedienrecht/muenchen.json";
import judgements_internetmedienrecht_muenchen from "./expertiseCity/judgements/internetmedienrecht/muenchen.json";
import core_internetmedienrecht_stuttgart from "./expertiseCity/core/internetmedienrecht/stuttgart.json";
import judgements_internetmedienrecht_stuttgart from "./expertiseCity/judgements/internetmedienrecht/stuttgart.json";
import core_prozessfuehrung_kaiserslautern from "./expertiseCity/core/prozessfuehrung/kaiserslautern.json";
import judgements_prozessfuehrung_kaiserslautern from "./expertiseCity/judgements/prozessfuehrung/kaiserslautern.json";
import core_prozessfuehrung_koblenz from "./expertiseCity/core/prozessfuehrung/koblenz.json";
import judgements_prozessfuehrung_koblenz from "./expertiseCity/judgements/prozessfuehrung/koblenz.json";
import core_prozessfuehrung_landau_pfalz from "./expertiseCity/core/prozessfuehrung/landau-pfalz.json";
import judgements_prozessfuehrung_landau_pfalz from "./expertiseCity/judgements/prozessfuehrung/landau-pfalz.json";
import core_prozessfuehrung_muenchen from "./expertiseCity/core/prozessfuehrung/muenchen.json";
import judgements_prozessfuehrung_muenchen from "./expertiseCity/judgements/prozessfuehrung/muenchen.json";
import core_prozessfuehrung_stuttgart from "./expertiseCity/core/prozessfuehrung/stuttgart.json";
import judgements_prozessfuehrung_stuttgart from "./expertiseCity/judgements/prozessfuehrung/stuttgart.json";
import core_startuprecht_kaiserslautern from "./expertiseCity/core/startuprecht/kaiserslautern.json";
import judgements_startuprecht_kaiserslautern from "./expertiseCity/judgements/startuprecht/kaiserslautern.json";
import core_startuprecht_koblenz from "./expertiseCity/core/startuprecht/koblenz.json";
import judgements_startuprecht_koblenz from "./expertiseCity/judgements/startuprecht/koblenz.json";
import core_startuprecht_landau_pfalz from "./expertiseCity/core/startuprecht/landau-pfalz.json";
import judgements_startuprecht_landau_pfalz from "./expertiseCity/judgements/startuprecht/landau-pfalz.json";
import core_startuprecht_muenchen from "./expertiseCity/core/startuprecht/muenchen.json";
import judgements_startuprecht_muenchen from "./expertiseCity/judgements/startuprecht/muenchen.json";
import core_startuprecht_stuttgart from "./expertiseCity/core/startuprecht/stuttgart.json";
import judgements_startuprecht_stuttgart from "./expertiseCity/judgements/startuprecht/stuttgart.json";
import core_steuerrecht_kaiserslautern from "./expertiseCity/core/steuerrecht/kaiserslautern.json";
import judgements_steuerrecht_kaiserslautern from "./expertiseCity/judgements/steuerrecht/kaiserslautern.json";
import core_steuerrecht_koblenz from "./expertiseCity/core/steuerrecht/koblenz.json";
import judgements_steuerrecht_koblenz from "./expertiseCity/judgements/steuerrecht/koblenz.json";
import core_steuerrecht_landau_pfalz from "./expertiseCity/core/steuerrecht/landau-pfalz.json";
import judgements_steuerrecht_landau_pfalz from "./expertiseCity/judgements/steuerrecht/landau-pfalz.json";
import core_steuerrecht_muenchen from "./expertiseCity/core/steuerrecht/muenchen.json";
import judgements_steuerrecht_muenchen from "./expertiseCity/judgements/steuerrecht/muenchen.json";
import core_steuerrecht_stuttgart from "./expertiseCity/core/steuerrecht/stuttgart.json";
import judgements_steuerrecht_stuttgart from "./expertiseCity/judgements/steuerrecht/stuttgart.json";

export const deExpertiseCity = {
  arbeitsrecht: {
    Kaiserslautern: {
      ...core_arbeitsrecht_kaiserslautern,
      judgements: judgements_arbeitsrecht_kaiserslautern,
    },
    Koblenz: {
      ...core_arbeitsrecht_koblenz,
      judgements: judgements_arbeitsrecht_koblenz,
    },
    Landau: {
      ...core_arbeitsrecht_landau_pfalz,
      judgements: judgements_arbeitsrecht_landau_pfalz,
    },
    München: {
      ...core_arbeitsrecht_muenchen,
      judgements: judgements_arbeitsrecht_muenchen,
    },
    Pirmasens: {
      ...core_arbeitsrecht_pirmasens,
      judgements: judgements_arbeitsrecht_pirmasens,
    },
    Stuttgart: {
      ...core_arbeitsrecht_stuttgart,
      judgements: judgements_arbeitsrecht_stuttgart,
    },
  },
  erbrecht: {
    Kaiserslautern: {
      ...core_erbrecht_kaiserslautern,
      judgements: judgements_erbrecht_kaiserslautern,
    },
    Koblenz: {
      ...core_erbrecht_koblenz,
      judgements: judgements_erbrecht_koblenz,
    },
    Landau: {
      ...core_erbrecht_landau_pfalz,
      judgements: judgements_erbrecht_landau_pfalz,
    },
    München: {
      ...core_erbrecht_muenchen,
      judgements: judgements_erbrecht_muenchen,
    },
    Pirmasens: {
      ...core_erbrecht_pirmasens,
      judgements: judgements_erbrecht_pirmasens,
    },
    Stuttgart: {
      ...core_erbrecht_stuttgart,
      judgements: judgements_erbrecht_stuttgart,
    },
  },
  gesellschaftsrecht: {
    Heilbronn: {
      ...core_gesellschaftsrecht_heilbronn,
      judgements: judgements_gesellschaftsrecht_heilbronn,
    },
    Kaiserslautern: {
      ...core_gesellschaftsrecht_kaiserslautern,
      judgements: judgements_gesellschaftsrecht_kaiserslautern,
    },
    Koblenz: {
      ...core_gesellschaftsrecht_koblenz,
      judgements: judgements_gesellschaftsrecht_koblenz,
    },
    Köln: {
      ...core_gesellschaftsrecht_koeln,
      judgements: judgements_gesellschaftsrecht_koeln,
    },
    Landau: {
      ...core_gesellschaftsrecht_landau_pfalz,
      judgements: judgements_gesellschaftsrecht_landau_pfalz,
    },
    München: {
      ...core_gesellschaftsrecht_muenchen,
      judgements: judgements_gesellschaftsrecht_muenchen,
    },
    Pirmasens: {
      ...core_gesellschaftsrecht_pirmasens,
      judgements: judgements_gesellschaftsrecht_pirmasens,
    },
    Stuttgart: {
      ...core_gesellschaftsrecht_stuttgart,
      judgements: judgements_gesellschaftsrecht_stuttgart,
    },
  },
  insolvenzrecht: {
    Koblenz: {
      ...core_insolvenzrecht_koblenz,
      judgements: judgements_insolvenzrecht_koblenz,
    },
    Köln: {
      ...core_insolvenzrecht_koeln,
      judgements: judgements_insolvenzrecht_koeln,
    },
    Landau: {
      ...core_insolvenzrecht_landau_pfalz,
      judgements: judgements_insolvenzrecht_landau_pfalz,
    },
  },
  internetmedienrecht: {
    Kaiserslautern: {
      ...core_internetmedienrecht_kaiserslautern,
      judgements: judgements_internetmedienrecht_kaiserslautern,
    },
    Koblenz: {
      ...core_internetmedienrecht_koblenz,
      judgements: judgements_internetmedienrecht_koblenz,
    },
    Landau: {
      ...core_internetmedienrecht_landau_pfalz,
      judgements: judgements_internetmedienrecht_landau_pfalz,
    },
    München: {
      ...core_internetmedienrecht_muenchen,
      judgements: judgements_internetmedienrecht_muenchen,
    },
    Stuttgart: {
      ...core_internetmedienrecht_stuttgart,
      judgements: judgements_internetmedienrecht_stuttgart,
    },
  },
  prozessfuehrung: {
    Kaiserslautern: {
      ...core_prozessfuehrung_kaiserslautern,
      judgements: judgements_prozessfuehrung_kaiserslautern,
    },
    Koblenz: {
      ...core_prozessfuehrung_koblenz,
      judgements: judgements_prozessfuehrung_koblenz,
    },
    Landau: {
      ...core_prozessfuehrung_landau_pfalz,
      judgements: judgements_prozessfuehrung_landau_pfalz,
    },
    München: {
      ...core_prozessfuehrung_muenchen,
      judgements: judgements_prozessfuehrung_muenchen,
    },
    Stuttgart: {
      ...core_prozessfuehrung_stuttgart,
      judgements: judgements_prozessfuehrung_stuttgart,
    },
  },
  startuprecht: {
    Kaiserslautern: {
      ...core_startuprecht_kaiserslautern,
      judgements: judgements_startuprecht_kaiserslautern,
    },
    Koblenz: {
      ...core_startuprecht_koblenz,
      judgements: judgements_startuprecht_koblenz,
    },
    Landau: {
      ...core_startuprecht_landau_pfalz,
      judgements: judgements_startuprecht_landau_pfalz,
    },
    München: {
      ...core_startuprecht_muenchen,
      judgements: judgements_startuprecht_muenchen,
    },
    Stuttgart: {
      ...core_startuprecht_stuttgart,
      judgements: judgements_startuprecht_stuttgart,
    },
  },
  steuerrecht: {
    Kaiserslautern: {
      ...core_steuerrecht_kaiserslautern,
      judgements: judgements_steuerrecht_kaiserslautern,
    },
    Koblenz: {
      ...core_steuerrecht_koblenz,
      judgements: judgements_steuerrecht_koblenz,
    },
    Landau: {
      ...core_steuerrecht_landau_pfalz,
      judgements: judgements_steuerrecht_landau_pfalz,
    },
    München: {
      ...core_steuerrecht_muenchen,
      judgements: judgements_steuerrecht_muenchen,
    },
    Stuttgart: {
      ...core_steuerrecht_stuttgart,
      judgements: judgements_steuerrecht_stuttgart,
    },
  },
} as const;
